export default __webpack_public_path__ + "static/media/selection.ede9a56a.svg";